import { useTranslation } from 'react-i18next';
import { cn } from '@shared/lib/utils';
import { formatRiskScore, riskBandClassName } from '../lib/labels';

interface RiskBandBadgeProps {
  band: string | null | undefined;
  score?: number | null;
  scoreBand?: string | null;
  className?: string;
}

export function RiskBandBadge({ band, score, scoreBand, className }: RiskBandBadgeProps) {
  const { t } = useTranslation('cabinet');
  const label = band ? t(`compliance.band.${band}`, { defaultValue: band }) : t('compliance.band.none');

  return (
    <span className="inline-flex min-w-0 flex-col gap-1">
      <span
        className={cn(
          'inline-flex w-fit items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
          riskBandClassName(band),
          className,
        )}
      >
        {score !== undefined && score !== null ? <span className="tabular-nums">{formatRiskScore(score)}</span> : null}
        <span>{label}</span>
      </span>
      {scoreBand && band && scoreBand !== band ? (
        <span className="text-xs text-muted-foreground">
          {t('compliance.shadowScore', { band: t(`compliance.band.${scoreBand}`, { defaultValue: scoreBand }) })}
        </span>
      ) : null}
    </span>
  );
}
